// extracted by mini-css-extract-plugin
module.exports = {"imageSource":"AuthorInfo_imageSource__2Y9zc","imagePopup":"AuthorInfo_imagePopup__--tQn","ellipsis":"AuthorInfo_ellipsis__3mrYz"};